"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STEP_DESCRIPTIONS = exports.FundingVerificationApproval = exports.FundingVerificationReport = exports.CalcAgent = exports.GenerateLoanTapes = exports.UserDataValidation = exports.MAX_ERRORS_PER_ENTRY = void 0;
// Re-export common values
var common_1 = require("./common");
Object.defineProperty(exports, "MAX_ERRORS_PER_ENTRY", { enumerable: true, get: function () { return common_1.MAX_ERRORS_PER_ENTRY; } });
// Re-export namespaces as modules
exports.UserDataValidation = __importStar(require("./UserDataValidation"));
exports.GenerateLoanTapes = __importStar(require("./GenerateLoanTapes"));
exports.CalcAgent = __importStar(require("./CalcAgent"));
exports.FundingVerificationReport = __importStar(require("./FundingVerificationReport"));
exports.FundingVerificationApproval = __importStar(require("./FundingVerificationApproval"));
// Import for ALL_STEP_DESCRIPTIONS and TypeCheckedProgressBreakdown
const UserDataValidation = __importStar(require("./UserDataValidation"));
const GenerateLoanTapes = __importStar(require("./GenerateLoanTapes"));
const CalcAgent = __importStar(require("./CalcAgent"));
const FundingVerificationReport = __importStar(require("./FundingVerificationReport"));
const FundingVerificationApproval = __importStar(require("./FundingVerificationApproval"));
exports.ALL_STEP_DESCRIPTIONS = [
    ...UserDataValidation.STEP_DESCRIPTIONS,
    ...GenerateLoanTapes.STEP_DESCRIPTIONS,
    ...CalcAgent.STEP_DESCRIPTIONS,
    ...FundingVerificationReport.STEP_DESCRIPTIONS,
    ...FundingVerificationApproval.STEP_DESCRIPTIONS,
];
//# sourceMappingURL=index.js.map